"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransferLines = void 0;
const helpers_1 = require("../../helpers");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getTransferLines = (order) => {
    if (!order)
        return [];
    if (!order.order_lines)
        return [];
    // loop through each order line and check if all versions are confirmed - IGNORE CANCELLED LINES
    const transfer_lines = [];
    order.order_lines.forEach((line) => {
        if (!line.versions)
            return;
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
        if (!latest_version)
            return;
        if (line.type === "TRANSFER" &&
            !helpers_1.CANCELLED_ORDER_STATUSES.includes(latest_version?.status))
            transfer_lines.push(line);
    });
    return transfer_lines;
};
exports.getTransferLines = getTransferLines;
